// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header .logo{-webkit-animation:appear .5s;animation:appear .5s}@media(max-width:1023px){header .logo{width:82px}header .logo svg{max-width:100%}}@-webkit-keyframes appear{0%{opacity:0}}@keyframes appear{0%{opacity:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
